// src/components/PlannerPreview.js
function PlannerPreview() {
    return (
      <>
        <div className="mt-3 sm:mt-4 md:mt-6 mb-8 sm:mb-12 md:mb-20">
          <div className="relative p-6 sm:p-8 md:p-12 lg:p-16 bg-gradient-to-br from-[#f8f8f8] via-[#f0f0f0] to-[#e8f0f0] rounded-[24px] md:rounded-[32px]">
            <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12">
              {/* Content Section */}
              <div className="flex-1">
                <div className="flex flex-col sm:flex-row items-center md:items-start gap-2 mb-4 md:mb-6">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl font-fraunces leading-[1.1] tracking-tighter text-center md:text-left">
                    Weekly Planner
                  </h2>
                  <span className="bg-black text-white px-4 py-2 rounded-full text-sm font-medium">
                    Coming Soon
                  </span>
                </div>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed tracking-tight mb-6 md:mb-8 text-center md:text-left mx-auto md:mx-0 max-w-[95%] md:max-w-[90%]">
                  A thoughtfully designed weekly planner to help you organize your days with style. Perfect for setting intentions, tracking goals, and making every week count. Each page is crafted to blend functionality with aesthetic beauty, making planning a delightful experience.
                </p>
  
                {/* Features Section */}
                <div className="mb-6 md:mb-8 bg-white/50 rounded-2xl p-4 md:p-6">
                  <h3 className="text-lg font-medium mb-3 text-center md:text-left">Planner Features:</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-black flex-shrink-0"></span>
                      60 sheets of premium quality paper
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-black flex-shrink-0"></span>
                      Hardcover with elegant finish
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-black flex-shrink-0"></span>
                      A5 size (148 × 210 mm)
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-black flex-shrink-0"></span>
                      Weekly layout with notes section
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-black flex-shrink-0"></span>
                      Minimalist design aesthetic
                    </li>
                  </ul>
                </div>
  
                {/* Price Section */}
                <div className="mb-4 md:mb-6 flex flex-col items-center md:items-start">
                  <div className="flex items-baseline gap-3 mb-1">
                    <span className="text-2xl md:text-3xl font-fraunces">₹699</span>
                    <span className="bg-yellow-100 text-yellow-800 text-sm px-3 py-1 rounded-full">Pre-order</span>
                  </div>
                  <span className="text-sm text-gray-600">Inclusive of delivery across India</span>
                </div>
  
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4 w-full sm:w-auto">
                  <button
                    onClick={() => window.location.href = 'mailto:deepaliagrawal224@gmail.com?subject=Weekly Planner Pre-order Inquiry'}
                    className="w-full sm:w-auto inline-flex items-center justify-center px-6 md:px-8 py-3 border-2 border-black text-black rounded-full hover:bg-black hover:text-white transition-colors duration-300 text-base md:text-lg"
                  >
                    Pre-order Now
                  </button>
                </div>
              </div>
  
              {/* Image Section */}
              <div className="w-full md:w-1/2 rounded-2xl overflow-hidden mt-6 md:mt-0">
                <div className="relative bg-gray-100 rounded-2xl aspect-[3/4] p-4">
                  <img 
                    src="/images/planner-preview.jpg" 
                    alt="Weekly Planner Preview"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default PlannerPreview;